/* @flow */
import BoxHeader from 'components/BoxHeader.jsx';
import Buttons from 'components/Buttons.jsx';
import Group from 'entities/Group';
import GroupMembership from 'entities/GroupMembership';
import * as React from 'react';
import Relationship from 'entities/Relationship';
import StartChatButton from 'user/components/StartChatButton.jsx';
import StatusLabel from 'components/StatusLabel.jsx';
import Subscriber from 'entities/Subscriber';
import Text from 'components/Text.jsx';
import UserActionsMenuButton from 'user/components/UserActionsMenuButton.jsx';
import PhoneCallButton from 'phoneCalls/components/PhoneCallButton.jsx';
import { isFixableDenialReason } from 'phoneCalls/components/PhoneCallModal.jsx';
import { withPhoneCallPermissions } from 'phoneCalls/lib/permissions';
import CurrentUser from 'auth/CurrentUser';

type Props = {
  relationship: Relationship,
  subscriber: Subscriber,
  groupToAdmin?: Group,
  groupMember?: GroupMembership,
  onRequestHide: Function,
  canMakePhoneCalls: boolean,
};

export class RelationshipViewHeader extends React.Component<Props> {
  renderHeaderAux = () => {
    const { relationship, subscriber, groupToAdmin, groupMember, canMakePhoneCalls } = this.props;
    const canPhone =
      (subscriber.getCanPhone() || isFixableDenialReason(subscriber.getCanPhoneDenialReason())) &&
      (CurrentUser.getUser().hasFeature('phone_calls') || canMakePhoneCalls);

    const sub = subscriber || (groupMember && groupMember.getSubscriber());
    return (
      <Buttons>
        {relationship.isEligibleForChat() && (
          <StartChatButton subscriber={subscriber} onRequestHide={this.props.onRequestHide} />
        )}
        {canPhone && (
          <PhoneCallButton
            calleeName={subscriber.getName()}
            calleeUuid={subscriber.getUuid()}
            size="xsmall"
          />
        )}
        <UserActionsMenuButton
          glyphSize="small"
          subscriber={sub}
          groupMembership={groupMember}
          groupToAdmin={groupToAdmin}
          showChangeRole={false}
          showCopyToClass={sub && sub.getCanBeCopiedToClass()}
          showMakeOwner={
            groupToAdmin && !groupToAdmin.isRoot() && groupMember && groupMember.getCanBecomeOwner()
          }
          showRemoveMember={
            groupToAdmin &&
            !groupToAdmin.isRoot() &&
            groupMember &&
            groupMember.hasPermission('can_remove_from_group')
          }
          showBlockMember={!!groupMember}
          showGetTranscript={groupMember && groupMember.hasPermission('can_admin')}
          showRemoveFromSchool={groupMember && groupMember.hasPermission('can_remove_from_org')}
          showReportAsUser={
            (groupToAdmin && groupToAdmin.isRoot()) ||
            (!groupMember || !groupMember.hasPermission('can_admin'))
          }
          showReportAsAdmin={
            groupToAdmin &&
            !groupToAdmin.isRoot() &&
            groupMember &&
            groupMember.hasPermission('can_admin')
          }
        />
      </Buttons>
    );
  };

  render() {
    const { relationship, subscriber } = this.props;

    let name = <Text truncate>{subscriber.getName()}</Text>;

    let status;
    if (relationship.isPendingForChat()) {
      status = 'Pending';
    } else if (relationship.isUnder13()) {
      status = 'Under 13';
    }

    if (status) {
      name = (
        <div>
          {name}
          <StatusLabel>{status}</StatusLabel>
        </div>
      );
    }

    return (
      <BoxHeader title={name} action={this.renderHeaderAux()} className="RelationshipViewHeader" />
    );
  }
}

export default withPhoneCallPermissions(RelationshipViewHeader);
